{
  "businessUnit": {
    "list": {
      "deviceCount": "{count} Geräte|{count} Gerät|{count} Geräte"
    },
    "settings": {
      "description": {
        "information": "Information",
        "title": "Information"
      },
      "button": "Einstellungen",
      "users": {
        "title": "Benutzer"
      },
      "firmwares": {
        "title": "Firmware"
      },
      "logs": {
        "title": "Protokolle"
      }
    },
    "name": "Name der Geschäftseinheit",
    "addOrganization": {
      "button": "Eine Organisation hinzufügen"
    },
    "leave": {
      "title": "Geschäftseinheit bearbeiten"
    }
  },
  "entityLocation": {
    "location": "Standort",
    "country": "Land",
    "latitude": "Breitengrad",
    "longitude": "Längengrad",
    "timezone": "Zeitzone",
    "countryError": "Land ist erforderlich.",
    "latitudeError": "Der Breitengrad muss zwischen -90 und 90 liegen.",
    "longitudeError": "Der Längengrad muss zwischen -180 und 180 liegen.",
    "timezoneError": "Zeitzone ist erforderlich.",
    "countryPlaceholder": "Das Land wählen",
    "countrySearchPlaceholder": "Nach dem Namen des Landes suchen",
    "countryPopular": "Beliebt"
  },
  "superAdministration": {
    "settings": {
      "title": "{name} ändern",
      "information": {
        "title": "Information",
        "subtitle": "Organisationsname",
        "nameLabel": "Name"
      },
      "button": "Einstellungen",
      "users": {
        "title": "Benutzer"
      },
      "pki": {
        "title": "PKI",
        "newConnection": "Neue Verbindung"
      },
      "logs": {
        "title": "Protokolle"
      }
    }
  },
  "organization": {
    "create": {
      "title": "Erstellung einer Organisation",
      "saveButton": "Die Organisation erstellen"
    },
    "information": {
      "title": "Organisationsinformationen"
    },
    "name": "Organisationsname",
    "type": {
      "label": "Typ",
      "placeholder": "Typ auswählen",
      "operator": "Betreiberorganisation",
      "administration": "Verwaltungsorganisation"
    },
    "nameRequiredError": "Der Name ist erforderlich.",
    "typeError": "Der Typ ist erforderlich.",
    "nameLengthError": "Länge zwischen {min} und {max} Zeichen.",
    "settings": {
      "information": {
        "title": "Information"
      },
      "description": {
        "title": "Beschreibung"
      },
      "users": {
        "title": "Benutzer"
      },
      "operationButton": "Betrieb",
      "logs": {
        "title": "Protokolle"
      },
      "license": {
        "title": "Lizenz"
      }
    },
    "leave": {
      "title": "Die Organisation bearbeiten",
      "message": "Alle nicht gespeicherten Daten gehen verloren."
    }
  },
  "entityAdmin": {
    "lastname": "Nachname des Administrators",
    "title": "Administratorinformationen",
    "firstname": "Vorname des Administrators",
    "login": "Benutzername des Administrators",
    "email": "Administrator-E-Mail",
    "language": "Sprache"
  },
  "country": {
    "GRC": "Griechenland",
    "MOZ": "Mosambik",
    "FRA": "Frankreich",
    "MUS": "Mauritius",
    "BWA": "Botswana",
    "CAF": "Zentralafrikanische Republik",
    "FIN": "Finnland",
    "KAZ": "Kasachstan",
    "MHL": "Marshallinseln",
    "MNE": "Montenegro",
    "MYS": "Malaysia",
    "NPL": "Nepal",
    "NZL": "Neuseeland",
    "PER": "Peru",
    "USA": "Vereinigte Staaten von Amerika",
    "YEM": "Jemen",
    "CMR": "Kamerun",
    "CUB": "Kuba",
    "DOM": "Dominikanische Republik",
    "ITA": "Italien",
    "LBR": "Liberia",
    "SWE": "Schweden",
    "TUN": "Tunesien",
    "WSM": "Samoa",
    "CUW": "Curaçao",
    "DNK": "Dänemark",
    "IDN": "Indonesien",
    "SGP": "Singapur",
    "SLV": "El Salvador",
    "UGA": "Uganda",
    "URY": "Uruguay",
    "VEN": "Venezuela (Bolivarische Republik)",
    "DEU": "Deutschland",
    "GUM": "Guam",
    "MKD": "Nordmazedonien",
    "MWI": "Malawi",
    "PAK": "Pakistan",
    "PRT": "Portugal",
    "BEL": "Belgien",
    "BOL": "Bolivien",
    "COM": "Komoren",
    "CHE": "Schweiz",
    "GHA": "Ghana",
    "IRN": "Iran (Islamische Republik)",
    "IRQ": "Irak",
    "JAM": "Jamaika",
    "NLD": "Niederlande",
    "POL": "Polen",
    "VAT": "Vatikanstadt",
    "AFG": "Afghanistan",
    "DZA": "Algerien",
    "HKG": "Hongkong",
    "LAO": "Laos",
    "NRU": "Nauru",
    "TKM": "Turkmenistan",
    "ZMB": "Sambia",
    "AUS": "Australien",
    "BHS": "Bahamas",
    "BIH": "Bosnien und Herzegowina",
    "CZE": "Tschechische Republik",
    "KOR": "Südkorea",
    "PHL": "Philippinen",
    "VCT": "St. Vincent und die Grenadinen",
    "ARM": "Armenien",
    "AZE": "Aserbaidschan",
    "BDI": "Burundi",
    "BGD": "Bangladesch",
    "ECU": "Ecuador",
    "ETH": "Äthiopien",
    "GAB": "Gabun",
    "GMB": "Gambia",
    "HTI": "Haiti",
    "KIR": "Kiribati",
    "MAC": "Macao",
    "MMR": "Myanmar",
    "PRI": "Puerto Rico",
    "QAT": "Katar",
    "SVK": "Slowakei",
    "TGO": "Togo",
    "UKR": "Ukraine",
    "CAN": "Kanada",
    "MLI": "Mali",
    "MNP": "Nördliche Marianeninseln",
    "SDN": "Sudan",
    "BRB": "Barbados",
    "FJI": "Fidschi",
    "KGZ": "Kirgisistan",
    "MAF": "Saint-Martin (französischer Teil)",
    "MRT": "Mauretanien",
    "ZWE": "Simbabwe",
    "CA-QC": "Quebec",
    "CHL": "Chile",
    "HRV": "Kroatien",
    "SAU": "Saudi-Arabien",
    "ASM": "Amerikanisch-Samoa",
    "BMU": "Bermuda",
    "COD": "Kongo (Demokratische Republik)",
    "CRI": "Costa Rica",
    "GIN": "Guinea",
    "IMN": "Isle of Man",
    "JPN": "Japan",
    "SLB": "Salomonen",
    "SMR": "San Marino",
    "SUR": "Suriname",
    "TCA": "Turks- und Caicosinseln",
    "ATG": "Antigua und Barbuda",
    "COG": "Kongo",
    "HND": "Honduras",
    "KNA": "St. Kitts und Nevis",
    "ROU": "Rumänien",
    "STP": "São Tomé und Príncipe",
    "ZAF": "Südafrika",
    "BGR": "Bulgarien",
    "BRN": "Brunei Darussalam",
    "CYP": "Zypern",
    "FSM": "Mikronesien (Föderierte Staaten von)",
    "MAR": "Marokko",
    "MDA": "Moldau (Republik)",
    "MDG": "Madagaskar",
    "MNG": "Mongolei",
    "SLE": "Sierra Leone",
    "TLS": "Osttimor",
    "VNM": "Vietnam",
    "AGO": "Angola",
    "BLZ": "Belize",
    "HUN": "Ungarn",
    "IRL": "Irland",
    "KWT": "Kuwait",
    "MDV": "Malediven",
    "NER": "Niger",
    "NIC": "Nicaragua",
    "PSE": "Palästina",
    "TWN": "Taiwan",
    "ARG": "Argentinien",
    "COL": "Kolumbien",
    "JOR": "Jordanien",
    "NAM": "Namibia",
    "SRB": "Serbien",
    "TJK": "Tadschikistan",
    "CPV": "Kap Verde",
    "GEO": "Georgien",
    "KOS": "Kosovo",
    "LUX": "Luxemburg",
    "OMN": "Oman",
    "RUS": "Russische Föderation",
    "SOM": "Somalia",
    "SYC": "Seychellen",
    "TCD": "Tschad",
    "TUV": "Tuvalu",
    "AND": "Andorra",
    "BHR": "Bahrain",
    "BRA": "Brasilien",
    "DJI": "Dschibuti",
    "DMA": "Dominica",
    "EST": "Estland",
    "ISR": "Israel",
    "MCO": "Monaco",
    "MLT": "Malta",
    "SEN": "Senegal",
    "SXM": "Sint Maarten (niederländischer Teil)",
    "VUT": "Vanuatu",
    "ABW": "Aruba",
    "BEN": "Benin",
    "BLR": "Belarus",
    "CYM": "Kaimaninseln",
    "GIB": "Gibraltar",
    "GNB": "Guinea-Bissau",
    "GRD": "Grenada",
    "IND": "Indien",
    "LBY": "Libyen",
    "LCA": "St. Lucia",
    "LVA": "Lettland",
    "PRK": "Korea (Demokratische Volksrepublik)",
    "SSD": "Südsudan",
    "TTO": "Trinidad und Tobago",
    "ALB": "Albanien",
    "BTN": "Bhutan",
    "CIV": "Elfenbeinküste",
    "LKA": "Sri Lanka",
    "PAN": "Panama",
    "SYR": "Syrien",
    "UZB": "Usbekistan",
    "AUT": "Österreich",
    "EGY": "Ägypten",
    "ERI": "Eritrea",
    "FRO": "Färöer-Inseln",
    "GNQ": "Äquatorialguinea",
    "GRL": "Grönland",
    "GUY": "Guyana",
    "LTU": "Litauen",
    "MEX": "Mexiko",
    "NOR": "Norwegen",
    "RWA": "Ruanda",
    "SWZ": "Swasiland",
    "THA": "Thailand",
    "ARE": "Vereinigte Arabische Emirate",
    "ESP": "Spanien",
    "GBR": "Vereinigtes Königreich von Großbritannien und Nordirland",
    "ISL": "Island",
    "KEN": "Kenia",
    "LSO": "Lesotho",
    "NGA": "Nigeria",
    "PLW": "Palau",
    "PNG": "Papua-Neuguinea",
    "BFA": "Burkina Faso",
    "CHN": "China",
    "KHM": "Kambodscha",
    "LBN": "Libanon",
    "LIE": "Liechtenstein",
    "PRY": "Paraguay",
    "SVN": "Slowenien",
    "TON": "Tonga",
    "TUR": "Türkei",
    "TZA": "Tansania",
    "VGB": "Jungferninseln (Britische)",
    "GTM": "Guatemala"
  },
  "relation": {
    "since": "Seit: {date}",
    "delete": {
      "confirm": {
        "title": "Die Beziehung löschen",
        "description": "Möchten Sie die Beziehung zu {name} wirklich löschen?"
      }
    }
  },
  "relations": {
    "affiliations": {
      "title": "Zugehörigkeit",
      "add": {
        "button": "Eine Zugehörigkeit hinzufügen"
      },
      "parentEntity": {
        "title": "Übergeordnete Einheit"
      },
      "childrenEntities": {
        "title": "Verbundene Einheiten"
      }
    },
    "delegations": {
      "title": "Delegation",
      "add": {
        "button": "Eine Delegation hinzufügen"
      }
    },
    "title": "Beziehungen",
    "add": {
      "createLink": "Eine Verbindung mit einer bestehenden Organisation erstellen",
      "createOrganization": "Eine neue Organisation erstellen"
    },
    "uploadIdCard": {
      "title": "Die ID-Karte der Organisation hochladen",
      "validation": {
        "fileMandatory": "Datei muss eine .JSON-Datei sein",
        "fileEmpty": "Die Datei darf nicht leer sein",
        "fileSize": "Die Datei darf höchstens 750 MB groß sein"
      }
    },
    "contact": {
      "administrator": "Administrator:",
      "noContact": "Kein Kontakt identifiziert",
      "referentUser": {
        "title": "Organisationskontakt",
        "description": "Benannte Kontaktperson für operative, Support- oder kommerzielle Anfragen im Zusammenhang mit dieser Organisation.",
        "selectUser": "Einen Benutzer auswählen",
        "modified": "Den Kontakt ändern"
      }
    }
  }
}
